module.exports = __webpack_public_path__ + "7dfbc4e425f7554dc8e81db9923f9cb4.png";